import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCart } from './context/CartContext';
import { mockTools } from './data/mockTools';
import { Reviews } from './Reviews';
import { RelatedTools } from './RelatedTools';
import './styles/ToolDetail.css';

const ToolDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [tool, setTool] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    // In a real app, this would be an API call
    const foundTool = mockTools.find(t => t.id === id);
    if (foundTool) {
      setTool(foundTool);
    } else {
      navigate('/business-tool-marketplace');
    }
  }, [id, navigate]);

  const handleAddToCart = () => {
    if (tool) {
      addToCart(tool);
    }
  };

  if (!tool) {
    return null;
  }

  return (
    <div className="tool-detail">
      <div className="tool-detail-header">
        <button 
          className="button button-secondary"
          onClick={() => navigate('/business-tool-marketplace')}
        >
          ← Back to Marketplace
        </button>
      </div>

      <div className="tool-detail-content">
        <div className="tool-detail-main">
          <div className="tool-detail-info">
            <h1 className="tool-detail-title">{tool.title}</h1>
            <div className="tool-detail-meta">
              <span className="tool-detail-author">
                by{' '}
                <a 
                  href={`/creator/${tool.authorId}`}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/business-tool-marketplace/creator/${tool.authorId}`);
                  }}
                >
                  {tool.author}
                </a>
              </span>
              <span className="tool-detail-category">{tool.category}</span>
            </div>
            <div className="tool-detail-tags">
              {tool.tags.map(tag => (
                <span key={tag} className="tag">{tag}</span>
              ))}
            </div>
          </div>

          {tool.imageUrl && (
            <div className="tool-detail-image">
              <img src={tool.imageUrl} alt={tool.title} />
            </div>
          )}

          <div className="tool-detail-description">
            <h2>Description</h2>
            <p>{tool.description}</p>
          </div>

          {tool.benefits && tool.benefits.length > 0 && (
            <div className="tool-detail-benefits">
              <h2>Key Benefits</h2>
              <ul>
                {tool.benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="tool-detail-files">
            <h2>Included Files</h2>
            <ul>
              {tool.files.map((file, index) => (
                <li key={index}>
                  <span className="file-name">{file.name}</span>
                  <span className="file-type">{file.type}</span>
                </li>
              ))}
            </ul>
          </div>

          <RelatedTools currentTool={tool} />
          <Reviews toolId={tool.id} />
        </div>

        <div className="tool-detail-sidebar">
          <div className="tool-detail-card">
            <div className="tool-detail-price">
              {tool.price === 0 ? 'Free' : `$${tool.price.toFixed(2)}`}
            </div>
            <button
              className="button button-primary"
              onClick={handleAddToCart}
              disabled={isProcessing}
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ToolDetail;